import React from 'react';

// Informational/preamble slide — renders a block of program text (no input).
// Records an acknowledgement answer on Continue so the text rides into the
// Beluga visit record (the submit envelope is built from answered slides;
// composeQaQuestionText emits slide.infoText as the Q text for type
// 'info-text'). Added for the TRT program intro per Beluga's 2026-06-02
// review of visit 11120290. Answer text is slide-configurable
// (`acknowledgeAnswer`) — Beluga asked the intro answer read
// "Great, lets get started" rather than "Acknowledged" (review of 28327327).
const InfoTextStep = ({ question, onAnswer, onNext }) => {
  const handleContinue = () => {
    onAnswer(question.acknowledgeAnswer || "Great, lets get started");
    onNext();
  };

  return (
    <div data-testid={`step-${question.id}`}>
      <h2 className="text-2xl md:text-3xl font-semibold text-center text-gray-900 mb-4">
        {question.question}
      </h2>

      <div className="bg-[#f8faf9] border border-gray-200 rounded-xl p-5 mb-6">
        <p className="text-gray-600 leading-relaxed whitespace-pre-line">
          {question.infoText}
        </p>
      </div>

      <button
        type="button"
        onClick={handleContinue}
        className="btn-primary"
        data-testid="continue-button"
      >
        Continue
      </button>
    </div>
  );
};

export default InfoTextStep;
